import React from 'react';

function DadJoke(props) {

     return (
       <div className="joke">
       <p>{props.joke}</p>
       </div>
     );

 }

 export default DadJoke;